import { render, staticRenderFns } from "./SuperadminConfigurations.vue?vue&type=template&id=b529c6b2&"
import script from "./SuperadminConfigurations.vue?vue&type=script&lang=js&"
export * from "./SuperadminConfigurations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports